import { ISpecialityData } from "src/app/shared/interfaces/SpecialityData.type";


export const specialityData: ISpecialityData = {
    'physicians': ['Anesthesiology', 'Cardiology', 'Dermatology', 'Emergency', 'Medicine', 'Endocrinology', 'Family Medicine', 'Gastroenterology', 'General Surgery', 'Geriatrics', 'Hematology', 'Infectious', 'Disease', 'Internal Medicine', 'Neurology', 'Nephrology', 'Obstetrics/Gynecology', 'Oncology', 'Ophthalmology', 'Orthopedics', 'Otolaryngology (ENT)', 'Pediatrics', 'Psychiatry', 'Pulmonology', 'Radiology', 'Rheumatology', 'Urology', 'Other'],
    'ecosystem': [],
    'drug-developers': [],
    'patients': []
}
